import { createFileRoute } from "@tanstack/react-router";
import StadiumLightingOverview from "@/pages/StadiumLightingOverview";
import { hubHead } from "@/lib/route-seo";

export const Route = createFileRoute("/stadium-sports-lighting/")({
  head: () => hubHead("/stadium-sports-lighting"),
  component: StadiumLightingOverview,
});
